import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {withStyles} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import {Menu, MenuItem,
    Drawer,AppBar,Toolbar,List,Typography,Divider, IconButton} from "@material-ui/core";
import { ChevronLeft } from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import {MainListItems, SecondaryListItems} from "./listItems";
import { Route, Switch} from "react-router-dom";
import { mainMenuItem, secondListItem } from "../../config/backendRoutes";
import {MoreVert} from "@material-ui/icons";
import Ability from "../../config/Ability";
//import Can from "../../services/RolePermissionService";

const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: "flex",
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: "none",
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: "relative",
        whiteSpace: "nowrap",
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing.unit * 7,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing.unit * 9,
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
        height: "100vh",
        overflow: "auto",
    },
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    h5: {
        marginBottom: theme.spacing.unit * 2,
    },
    active: {
        backgroundColor: theme.palette.action.selected
    },
});

const ITEM_HEIGHT = 48;

class Admin extends React.Component {
    state = {
        open: false,
        anchorEl: null,
    };

    handleDrawerOpen = () => {
        this.setState({open: true});
    };

    handleDrawerClose = () => {
        this.setState({open: false});
    };

    handleClick = event => {
        this.setState({anchorEl: event.currentTarget});
    };

    handleClose = () => {
        this.setState({anchorEl: null});
    };

    componentWillMount() {
        if (!Ability.can("view","/admin")) {
            this.props.history.push("/");
        }else if (this.props.location.pathname === "/admin") {
            this.props.history.push("/admin/dashboard");
        }
    }

    componentDidUpdate() {
        if (!Ability.can("view","/admin")) {
            this.props.history.push("/");
        }
    }

    logOut = () => {
        this.setState({anchorEl: null});
        this.props.userLogOut();
    };

    goHome = () => {
        this.setState({anchorEl: null});
        this.props.history.push("/");
    };

    render() {
        const {classes} = this.props;
        const Location = this.props.location.pathname;
        const {anchorEl} = this.state;
        const openMenu = Boolean(anchorEl);
        //console.log(Ability)
        //console.log("adminpage", this.props);

        return (
            <div className={classes.root}>
                <CssBaseline/>
                <AppBar
                    position="absolute"
                    className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
                >
                    <Toolbar disableGutters={!this.state.open} className={classes.toolbar}>
                        <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerOpen}
                            className={classNames(
                                classes.menuButton,
                                this.state.open && classes.menuButtonHidden,
                            )}
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            className={classes.title}
                        >
                            Dashboard
                        </Typography>
                        {/* <IconButton color="inherit">
                            <Badge badgeContent={4} color="secondary">
                                <Notifications/>
                            </Badge>
                        </IconButton> */}
                        <IconButton
                            color="inherit"
                            aria-label="More"
                            aria-owns={openMenu ? "long-menu" : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                        >
                            <MoreVert/>
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            open={openMenu}
                            onClose={this.handleClose}
                            PaperProps={{
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                    width: 200,
                                },
                            }}
                        >
                            <MenuItem onClick={this.goHome}> Home </MenuItem>
                            <MenuItem onClick={this.logOut}> Logout </MenuItem>
                        </Menu>
                    </Toolbar>
                </AppBar>
                

                <Drawer
                    variant="permanent"
                    classes={{
                        paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                    }}
                    open={this.state.open}
                >
                    <div className={classes.toolbarIcon}>
                        <IconButton onClick={this.handleDrawerClose}>
                            <ChevronLeft/>
                        </IconButton>
                    </div>
                    <Divider/>
                    <List>
                        <MainListItems open={this.state.open} location={Location}/>
                    </List>
                    <Divider/>
                    <List>
                        <SecondaryListItems open={this.state.open} location={Location}/>
                    </List>
                </Drawer>

                <main className={classes.content}>
                    <div className={classes.appBarSpacer}/>

                    {/* TODO  RESTIRCT ROUTES */}
                    <Switch>
                        {mainMenuItem.map(routesList =>(
                            <Route key={routesList.name} exact path={routesList.url} component={routesList.component}/>
                        ))}  
                        {secondListItem.map(routesList =>(
                            <Route key={routesList.name} exact path={routesList.url} component={routesList.component}/>
                        ))}                    
                    </Switch>

                </main>
            </div>
        );
    }
}

Admin.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Admin);